<template>
  <section class="content-panel">
    <div class="section-head">
      <div>
        <h2>客户列表</h2>
        <p>维护客户账户、额度及投放状态</p>
      </div>
      <div class="head-actions">
        <el-input
          v-model.trim="keyword"
          placeholder="搜索账号"
          clearable
          class="search-input"
          :prefix-icon="Search"
          @keyup.enter="search"
          @clear="search"
        />
        <el-button type="primary" @click="search">查询</el-button>
        <el-button type="primary" @click="openCreate">
          <el-icon><Plus /></el-icon>新增客户
        </el-button>
      </div>
    </div>

    <el-table :data="admin.customers.value" stripe>
      <el-table-column type="index" label="#" width="56" />
      <el-table-column prop="phone" label="账号" min-width="140" />
      <el-table-column prop="balance" label="剩余额度" min-width="110">
        <template #default="{ row }"><span class="amount">{{ row.balance }} 次</span></template>
      </el-table-column>
      <el-table-column prop="deviceCount" label="设备" width="80" align="center" />
      <el-table-column prop="appCount" label="应用" width="80" align="center" />
      <el-table-column label="账户状态" width="100">
        <template #default="{ row }">
          <el-tag :type="row.status === 1 ? 'success' : 'danger'" effect="light">
            {{ row.status === 1 ? '正常' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="广告状态" width="100">
        <template #default="{ row }">
          <el-tag :type="row.adEnabled === 1 ? 'primary' : 'info'" effect="light">
            {{ row.adEnabled === 1 ? '投放中' : '已暂停' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="360" fixed="right">
        <template #default="{ row }">
          <el-button link type="primary" @click="view(row.id)">查看设备</el-button>
          <el-button link @click="admin.toggleAd(row)">{{ row.adEnabled === 1 ? '暂停广告' : '启用广告' }}</el-button>
          <el-button link :type="row.status === 1 ? 'danger' : 'success'" @click="admin.changeStatus(row)">
            {{ row.status === 1 ? '禁用' : '恢复' }}
          </el-button>
          <el-button link type="primary" @click="admin.recharge(row)">充值</el-button>
          <el-button link type="warning" @click="admin.manualAdjust(row)">调账</el-button>
          <el-button link type="info" @click="admin.refund(row)">退款</el-button>
          <el-button link @click="openBalanceLog(row.id)">流水</el-button>
        </template>
      </el-table-column>
      <template #empty><el-empty description="暂无客户数据" /></template>
    </el-table>

    <div class="panel-footer">
      <el-pagination
        :current-page="admin.customerPagination.page"
        :page-size="admin.customerPagination.size"
        :page-sizes="[10, 20, 50, 100]"
        :total="admin.customerPagination.total"
        layout="total, sizes, prev, pager, next, jumper"
        background
        @current-change="onPageChange"
        @size-change="onSizeChange"
      />
    </div>

    <el-dialog v-model="createDialog" title="新增客户" width="520px">
      <el-form ref="createFormRef" :model="createForm" :rules="createRules" label-position="top">
        <el-form-item label="账号" prop="phone">
          <el-input v-model.trim="createForm.phone" placeholder="请输入客户账号" />
        </el-form-item>
        <div class="form-row">
          <el-form-item label="初始密码" prop="password">
            <el-input v-model="createForm.password" show-password />
          </el-form-item>
          <el-form-item label="初始额度(次)" prop="balance">
            <el-input-number v-model="createForm.balance" :min="0" :precision="0" controls-position="right" />
          </el-form-item>
        </div>
      </el-form>
      <template #footer>
        <el-button @click="createDialog = false">取消</el-button>
        <el-button type="primary" @click="submitCreate">确认创建</el-button>
      </template>
    </el-dialog>
  </section>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { Plus, Search } from '@element-plus/icons-vue'
import { ElMessage } from 'element-plus'

const props = defineProps({ admin: Object })
const emit = defineEmits(['navigate'])

const createDialog = ref(false)
const createFormRef = ref()
const keyword = ref(props.admin.customerPagination.keyword || '')

const createForm = reactive({ phone: '', password: '123456', balance: 100 })
const createRules = {
  phone: [{ required: true, message: '请输入客户账号' }],
  password: [{ required: true, message: '请输入初始密码' }]
}

async function search() {
  try {
    await props.admin.loadCustomers({ page: 1, keyword: keyword.value })
  } catch (error) {
    ElMessage.error(error.message)
  }
}

async function onPageChange(page) {
  try {
    await props.admin.loadCustomers({ page })
  } catch (error) {
    ElMessage.error(error.message)
  }
}

async function onSizeChange(size) {
  try {
    await props.admin.loadCustomers({ page: 1, size })
  } catch (error) {
    ElMessage.error(error.message)
  }
}

function openCreate() {
  Object.assign(createForm, { phone: '', password: '123456', balance: 100 })
  createDialog.value = true
}

const submitCreate = async () => {
  if (!await createFormRef.value.validate().catch(() => false)) return
  await props.admin.createCustomer(createForm)
  createDialog.value = false
  await search()
}

const view = async (id) => {
  await props.admin.selectCustomer(id)
  emit('navigate', 'devices')
}

const openBalanceLog = async (id) => {
  await props.admin.selectCustomer(id)
  emit('navigate', 'balance-log')
}
</script>
